import { render, staticRenderFns } from "./DeclinedReasonsPieChart.vue?vue&type=template&id=bec6fb7c&scoped=true"
import script from "./DeclinedReasonsPieChart.vue?vue&type=script&lang=ts"
export * from "./DeclinedReasonsPieChart.vue?vue&type=script&lang=ts"
import style0 from "./DeclinedReasonsPieChart.vue?vue&type=style&index=0&id=bec6fb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec6fb7c",
  null
  
)

export default component.exports